import { Injectable } from '@angular/core';
import { AuthenticationService } from './authentication.service';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import * as appApiResources from '../../shared/globalcontants';
import { CommonService } from 'src/app/shared/services/common.service';


@Injectable()
export class AuthGuardService {

  constructor(private authentication: AuthenticationService, private router: Router, private _cs: CommonService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

    if (localStorage.getItem(appApiResources.userSessionName)) {
      if (localStorage.getItem(appApiResources.instanceName)) {
        this._cs.showSettingLogin = false;
      } else {
        this._cs.showSettingLogin = true;
      }
      return true;
    } else {
      if (state.url === '/settings-configuration') {
        this._cs.showSettingLogin = true;
        return true;
      }
    }
    if (!this._cs.isonlineStatus) {
      this._cs.showSettingLogin = false;
      return true;
    }
    this.redirectToLoginPage(state);

  }

  redirectToLoginPage(state: RouterStateSnapshot) {
    this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
  }

}
